module.exports = require("./ses.d.ts");